/* eslint react/jsx-key: off */
import React from 'react'
import { Create, FormTab, SaveButton, TabbedForm, TextInput, RefreshButton, Toolbar, required, minLength, maxLength, TopToolbar, ListButton, BooleanInput } from 'react-admin'

const UserCreateToolbar = ({ ...props }) => (
  <Toolbar { ...props }>
    <SaveButton
      label='Save'
      redirect='list'
      submitOnEnter
    />
  </Toolbar>
)

const confirmPasswordValidation = (value, allValues) => {

  if (allValues.Authentication.password != allValues.Authentication.confirmation) {
    return 'Those passwords didn\'t match. Try again.';
  }
}

export const CreateActions = ({ basePath, data, resource }) => (
  <TopToolbar>
    <ListButton basePath={ basePath } record={ data } />
    <RefreshButton basePath={ basePath } record={ data } />
  </TopToolbar>
);

const UserCreate = ({ ...props }) => (
  <Create { ...props } actions={ <CreateActions /> } >
    <TabbedForm toolbar={ <UserCreateToolbar /> }>

      <FormTab label='Authentication Info'>

        <TextInput label='Username' source='Authentication.username' validate={ [required()] } />
        <TextInput label='Password' source='Authentication.password' type='password' validate={ required() } />
        <TextInput label='Confirm Password' source='Authentication.confirmation' type='password' validate={ [required(), confirmPasswordValidation] } />


      </FormTab>

      <FormTab label='General User Data'>
        <TextInput label='First name' source='name' />
        <TextInput label='Last Name' source='last_name' />
        <TextInput label='Email' source='email' type='email' validate={ required() } />
        <TextInput label='Phone' source='phone' />
      </FormTab>

      <FormTab label="Web APP Permissions" >
        <BooleanInput source="Authentication.Permission.web_app_traderev_auto_proxy" label="TradeRev Auto Proxy" validate={ required() } defaultValue={ false } />
        <BooleanInput source="Authentication.Permission.web_app_user" label="Users" validate={ required() } defaultValue={ false } />
      </FormTab>


    </TabbedForm>
  </Create>
)

export default UserCreate
